import React from 'react';
import {Label, WarningMessage} from 'components';
import i18n from 'i18next';
import ImageUploaderField from 'components/ImageUploaderField';

type ImageFormProps = {
  // the image id to show, if nothing is uploaded yet
  imageId?: string;
  // the uploaded file
  uploadedFile?: File;
  // listener for uploaded file
  setFile: (file: File) => void;
  disabled?: boolean;
};

function ImageForm({imageId, uploadedFile, setFile, disabled}: ImageFormProps) {
  return (
    <Label
      htmlFor="image-form"
      label={i18n.t('wisbitPage.addComponentModal.imageFormLabel')}
    >
      <ImageUploaderField
        imageId={imageId}
        uploadedFile={uploadedFile}
        onChange={setFile}
        // className="w-full h-64"
        disabled={disabled}
      />
      <WarningMessage className="mt-4">
        {i18n.t('wisbitPage.addComponentModal.imageForm.confirmReminder')}
      </WarningMessage>
    </Label>
  );
}

export default ImageForm;
